import { OrderedMap } from 'immutable';
import type { ContactInfo, ID, ReduxAction } from '../../types';
import { AppState } from '@reducers/rootReducer';

export type SharedContactSourcesState = OrderedMap<ID, ContactInfo[]>;
const initialSharedContactSourcesState = OrderedMap<ID, ContactInfo[]>();

export const selectSharedContactSources = (contactUUID: ID) => (state: AppState) =>
  state.sharedData.sources.get(contactUUID, []);

export function sharedContactSourcesReducer(
  state: SharedContactSourcesState = initialSharedContactSourcesState,
  { type, payload }: ReduxAction,
) {
  switch (type) {
    case 'FETCH_SHARED_CONTACT_SOURCES_SUCCEEDED':
      return state.set(payload.contactUUID, payload.response);

    default:
      return state;
  }
}
